import { SendOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import ShopComponent from "./components/ShopComponent";
import { createShop, getExpertShop } from "../../service/shopApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

function Shop() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [shopStatus, setShopStatus] = useState();

  const queryClient = useQueryClient();
  const shopQuery = useQuery(["expertShop"], getExpertShop);
  const shopMutation = useMutation(createShop, {
    onSuccess: () => {
      queryClient.invalidateQueries("expertShop");
    },
  });
  let shopData = shopQuery?.data?.shop;

  useEffect(() => {
    setShopStatus(shopQuery?.data?.shop?.shopStatus);
  }, [shopQuery?.data?.shop?.shopStatus]);
  return (
    <div className="p-6 max-lg:p-3  h-full">
      {shopStatus === "DISABLE" ? (
        <section className="flex flex-col gap-2 font-body text-center  p-3 rounded-lg bg-white h-2/3 w-[80%] m-auto ">
          <div className="flex flex-col justify-center gap-6 border-dashed border-2 p-3 h-full items-center">
            <h2 className="text-3xl">فعال سازی فروشگاه</h2>
            <p className="tracking-tight">
              کارشناس گرامی، شما میتوانید در صفحه کارشناسی خود، فروشگاه اختصاصی
              داشته باشید و محصولات خود را به فروش برسانید. فروشگاه شما میتواند
              شامل انواع محصولات قابل ارائه در بستر کشاورزی شامل کود، سم، بذر،
              ادوات، ماشین آلات، ابزار و تجهیزات کشاورزی و ... باشد.
            </p>
            <p className="text-xl w-[80%]">
              جهت فعال‌سازی فروشگاه در صفحه کارشناسی خود، شماره تماس فروشگاه خود
              را برای ارتباط خریداران وارد نمائید.
            </p>
            <Input
              onChange={(e) => setPhoneNumber(e.target.value)}
              autoFocus={true}
              className="text-center w-2/3 text-xl "
              type="number"
              placeholder="شماره همراه یا تلفن ثابت"
            />
            <Button
              onClick={() => shopMutation.mutate({ phoneNumber: phoneNumber })}
              icon={<SendOutlined />}
              className="w-1/3 h-fit bg-gradient-to-r from-blue-950 to-blue-700 rounded-[20px] text-xl text-white"
            >
              ارسال
            </Button>
          </div>
        </section>
      ) : (
        <ShopComponent shopData={shopData} />
      )}
    </div>
  );
}

export default Shop;
